// extracted by mini-css-extract-plugin
export default {"headingContainer":"styles_headingContainer__NyQu8","white":"styles_white__T+LUI"};